
import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NestedProperty } from "../../decorators/EntityDecorators";
import { RegexType } from "../../services/RegexPatternLibrary";
import { Employee } from "./Employee.model";
import { PointOfService } from "./PointOfService.model";

export class Event extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Start Date"
  })
  startDate!: Date;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "End Date"
  })
  endDate!: Date;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.Required,
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn
    ],
    PropretyDisplayName: "Subject"
  })
  @Validation({
    maxLength: 255
  })
  subject!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Body"
  })
  body!: string;

  @NestedProperty({
    PropretyDisplayName: "Organizer",
    PropretyPluralName: "Organizers",
    ShowInTab: false,
    AddInplaceProprety: false,
    TargetType: Employee
  })
  organizer!: Employee;

  @NestedProperty({
    PropretyDisplayName: "Point of Service",
    PropretyPluralName: "Points of Service",
    ShowInTab: false,
    AddInplaceProprety: false,
    TargetType: PointOfService
  })
  pointOfService!: PointOfService;

  GetType(): IEntityMetaData {
    return Event.getMetaData();
  }
}
